import React from 'react';
import JiraCallbackComponent from '../components/integrations/JiraCallbackComponent';
import NewLayout from '../layout/dashboard/NewLayout';

const JiraCallback = () => {
  return (
    <NewLayout>
      <JiraCallbackComponent />
    </NewLayout>
  );
};

export default JiraCallback;
